<script>
import Layout from '@layouts/root'

export default {
  metaInfo: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <VContainer fluid fill-height>
      <VLayout align-center justify-center>
        <Transition appear>
          <BaseIcon :class="$style.loadingIcon" name="sync" spin />
        </Transition>
      </VLayout>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.loadingIcon {
  @extend %typography-xxlarge;

  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
